import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldNa = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.1133 4.07031L11.2383 0.789062C11.0332 0.707031 10.7051 0.625 10.5 0.625C10.2539 0.625 9.92578 0.707031 9.7207 0.789062L1.8457 4.07031C1.10742 4.39844 0.65625 5.0957 0.65625 5.875C0.65625 16.457 8.4082 21.625 10.459 21.625C12.5918 21.625 20.3438 16.375 20.3438 5.875C20.3438 5.0957 19.8516 4.39844 19.1133 4.07031ZM10.459 19.6562C6.68555 18.0977 2.625 13.0938 2.625 5.91602L10.418 2.63477C10.459 2.63477 10.459 2.63477 10.5 2.63477L18.375 5.875C18.375 14.2012 13.207 18.5488 10.459 19.6562ZM7.21875 10.1406C6.64453 10.1406 6.23438 10.5918 6.23438 11.125C6.23438 11.6582 6.68555 12.0684 7.21875 12.0684H13.7812C14.3145 12.0684 14.7246 11.6172 14.7246 11.125C14.7246 10.5918 14.3145 10.1406 13.7812 10.1406H7.21875Z",
		fill: "#949494"
	})]
});
const ForwardRef = forwardRef(SvgIconShieldNa);
export { ForwardRef as ReactComponent };
